<template>
  <div class="car-manage">
    <!-- 查找参数区 -->
    <div class="filter-container">
      <!-- <el-input placeholder="请输入车辆名称" v-model="listQuery.params.name" style="width: 200px" class="filter-item"
        @input="e => listQuery.params.name = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
      <el-input placeholder="请输入单位名称" v-model="listQuery.params.entityName" style="width: 200px" class="filter-item"
        @input="e => listQuery.params.entityName = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
      <el-select v-model="listQuery.params.status" placeholder="工作状态" clearable style="width: 120px"
        class="filter-item">
        <el-option v-for="(item, index) in statusOptions" :key="index" :value="item">
        </el-option>
      </el-select>
      <el-select v-model="listQuery.params.isRobot" placeholder="设备类型" clearable style="width: 120px"
        class="filter-item">
        <el-option v-for="(item, index) in typeOptions" :key="index" :value="item">
        </el-option>
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px"
        @click="handleFilter(true)">
        搜索
      </el-button> -->
      <!-- <el-button class="filter-item" style="margin-left: 10px;" type="danger" icon="el-icon-delete"
        @click="handleDeleteAll">
        批量删除
      </el-button> -->
      <!-- 旧 -->
      <!-- <searchContent @queryDevice="queryDevice"></searchContent> -->
      <!-- 新 -->
      <CategorySearch :conditions="conditionMap" @search="search"></CategorySearch>
      
    </div>
    <!-- 数据列表区 -->
    <el-table :data="listData" v-loading="listLoading" border highlight-current-row style="width: 100%;align: center;"
      @selection-change="handleSelectionChange" :row-key="getRowKey">

      <el-table-column type="selection" width="40" :reserve-selection="true">
      </el-table-column>
      <el-table-column prop="id" label="机器人ID" width="200" align="center">
      </el-table-column>
      <el-table-column prop="name" label="机器人名称" align="center">
      </el-table-column>
	  <el-table-column prop="factoryName" label="初始名称" align="center">
	  </el-table-column>
      <el-table-column prop="entityName" label="运营单位" width="200" align="center">
      </el-table-column>
      <el-table-column prop="entityId" label="运营单位ID" v-if="false">
      </el-table-column>
      <el-table-column prop="healthStatusName" label="健康状态" align="center">
      </el-table-column>
      <el-table-column prop="workStatusName" label="工作状态" align="center">
      </el-table-column>
      <el-table-column prop="power" label="电池电量" align="center">
      </el-table-column>
      <el-table-column prop="typeName" label="机器人类型" align="center">
      </el-table-column>
      <el-table-column prop="modelName" label="机器人型号" align="center">
      </el-table-column>
<!--      <el-table-column prop="isRobot" label="设备类型" align="center">
      </el-table-column> -->
      <el-table-column prop="longitude" label="经度" align="center">
      </el-table-column>
      <el-table-column prop="latitude" label="纬度" align="center">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="200" align="center">
      </el-table-column>
      <el-table-column prop="operator" label="操作" width="150" align="center">
        <template v-slot:="{row,$index}">
          <el-select value="操作类型">
            <el-option v-for="(item, index) in tableOptions" :key="item" :value="index"
              @click.native="handleOperator(index, row)">
              {{item}}
            </el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页栏 -->
    <pagination :total="totalCounts" :page="carCategoryQuery.pageIndex"  @pagination="handlePageChange">
    </pagination>

    <!-- 编辑车辆信息弹出框 -->
    <el-dialog title="编辑机器人信息" :visible.sync="editCarDialog">
      <el-form :model="editCarForm" ref="editCarForm" label-position="right" label-width="80px">
        <el-form-item label="机器人ID" prop="carEditId">
          <el-input v-model="editCarForm.carEditId" :disabled="isSearch"></el-input>
        </el-form-item>
        <el-form-item label="机器人名称">
          <el-input v-model="editCarForm.carEditName" maxlength="20"
            @input="e => editCarForm.carEditName = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
        </el-form-item>
       <!-- <el-form-item label="设备类型" prop="carEditIsRobot">
          <el-input v-model="editCarForm.carEditIsRobotName" readonly></el-input>
        </el-form-item> -->
       <el-form-item label="机器人类型">
          <el-select v-model="editCarForm.carEditTypeId" style="width:100%" @change="selectCarTypeName(editCarForm.carEditTypeName)" 
					:disabled="isSearch" >
            <el-option v-for="item in carTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机器人型号">
          <el-select v-model="editCarForm.carEditModelId" style="width:100%">
            <el-option v-for="item in selectedCarTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运营单位">
          <el-select v-model="editCarForm.carEditEntityId" style="width:100%">
            <el-option v-for="item in entityInfoOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
		<el-form-item label="机器人图片">
		  <el-input v-model="editCarForm.carEditImg" maxlength="60" ></el-input>
		</el-form-item>
		<el-form-item label="机器人WIFi">
		  <el-input v-model="editCarForm.carEditWifiName" maxlength="20"
		    @input="e => editCarForm.carEditWifiName = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
		</el-form-item>
		<el-form-item label="WIFI密码">
		  <el-input v-model="editCarForm.carEditwifiPassword" maxlength="20"
		    @input="e => editCarForm.carEditwifiPassword = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
		</el-form-item>
		<el-form-item label="水箱容量">
		  <el-input v-model="editCarForm.carEditWeight" maxlength="20"
		    @input="e => editCarForm.carEditWeight = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
		</el-form-item>
		<el-form-item label="垃圾箱容量">
		  <el-input v-model="editCarForm.carEditMaxWeight" maxlength="20"
		    @input="e => editCarForm.carEditMaxWeight = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
		</el-form-item>
		<el-form-item label="4G账号">
		  <el-input v-model="editCarForm.carEditNum4g" maxlength="20"
		    @input="e => editCarForm.carEditNum4g = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
		</el-form-item>
		<el-form-item label="4G账号启动时间">		 
		  <el-date-picker
		    :clearable="false"
		    v-model="editCarForm.carEditActive4g"
		    type="datetime"
		    placeholder="选择日期"
		    value-format="yyyy-MM-dd HH:mm:ss">
			</el-date-picker>		
		</el-form-item>
		<el-form-item label="差分账号">
		  <el-input v-model="editCarForm.carEditNumDiffer" maxlength="20"
		    @input="e => editCarForm.carEditNumDiffer = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
		</el-form-item>
		<el-form-item label="差分账号启动时间">			
			<el-date-picker
			  :clearable="false"
			  v-model="editCarForm.carEditActiveDiffer"
			  type="datetime"
			  placeholder="选择日期"
			  value-format="yyyy-MM-dd HH:mm:ss">
			</el-date-picker>	
		</el-form-item>	
		<el-form-item label="差分账号到账时间">
			<el-date-picker
			  :clearable="false"
			  v-model="editCarForm.carEditDeathDiffer"
			  type="datetime"
			  placeholder="选择日期"
			  value-format="yyyy-MM-dd HH:mm:ss">
			</el-date-picker>	
		</el-form-item>	
		<el-form-item label="对外推送" prop="editCarForm.carEditExternalFlag">
		  <el-radio v-model="editCarForm.carEditExternalFlag" :label="0">否</el-radio>
		  <el-radio v-model="editCarForm.carEditExternalFlag" :label="1">是</el-radio>
		</el-form-item>
		
		<el-form-item label="故障码版本" prop="editCarForm.carEditExceptionCodeVersion">
		  <el-radio v-model="editCarForm.carEditExceptionCodeVersion" :label="0">旧</el-radio>
		  <el-radio v-model="editCarForm.carEditExceptionCodeVersion" :label="1">新</el-radio>
		</el-form-item>
		
        <!-- <el-form-item label="车辆状态">
          <el-select v-model="editCarForm.carEditStatus" style="width:100%" :disabled="isSearch">
            <el-option v-for="item in entityInfoStatus" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editCarDialog = false">取 消</el-button>
        <el-button type="primary" @click="editCarBtn()">确 定</el-button>
      </div>
    </el-dialog>
	
	<!--为车辆添加用户 -->
	<el-dialog title="机器人用户信息" :visible.sync="editCarUserVisible">
		<el-form :model="editCarUser" ref="editCarUser" label-position="right" label-width="80px">
			<!-- <el-form-item label="支持用户" prop="carUsers">
			  <el-input v-model="editCarUser.carUsers" :disabled="isSearch"></el-input>
			</el-form-item> -->
			<el-table :data="editCarUser.carUsers" :row-key="getRowKey">
				<el-table-column prop="title"  align="center"></el-table-column>
				<el-table-column prop="name" align="center"></el-table-column>
				<el-table-column>
					 <template v-slot:="{row,$index}">
						 <el-button type="primary" size="mini" @click="handlDeleteCarUser(editCarUser.editCarId,row.name)">
						   删除
						 </el-button>
					</template>
				</el-table-column>
			</el-table>
			
			<p style="height:30px"></p>
			
			<el-form-item label="选择用户">
				<el-select v-model="editCarUser.editUserName" style="width:100%">
					<el-option v-for="item in usersOptions" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="editCarUserVisible = false">取 消</el-button>
			<el-button type="primary" @click="handleEditCarUserForm()">确 定</el-button>
		</div>
	</el-dialog>

  </div>
</template>

<script>
  import Pagination from '@/components/common/Pagination'
  import { formatDate} from '@/utils/date'
  import { carList,carCategorySearch,carEditFunction,carDelete,getCarTypes,getNotRepeatingCarTypes,getTypesByCarTypeName,
		getCarUsers,insertCarUserTra,deleteCarUserTra } from '@/api/car'
  import { listCarUserByEntity  } from '@/api/user.js'
  import { mqttPushCarBasic  } from '@/api/mqtt.js'
	
   import { stat } from 'fs'
	//
   import searchContentVue from './searchContent.vue'
   import SearchContent from './searchContent.vue'
   import CategorySearch from './CategorySearch.vue'

  export default {
    name: 'CarManage',
    components: {
		Pagination,
		SearchContent,
		CategorySearch
	},
	mounted() {
	  this.init()
	  // this.handleFilter()
	},
    data() {
      return {
		usersOptions:[],  
		editCarUserVisible:false,
		editCarUser:{
			carUsers:'',
			editCarId:'',
			editUserName:''
		},  

        // 编辑状态
        isSearch: true,

        listLoading: true,
        listData: [],
        totalCounts: 0,
        //编辑车辆信息弹出框
        editCarDialog: false,
        listQuery: {
          entityId: this.$store.getters['user/entityId'],
          pageIndex: 1,
          pageSize: 10,
          params: {
            name: undefined,
            entityName: undefined,
            status: undefined,
            isRobot: undefined,
          },
          fuzzySearch: true
        },
        //车辆查询条件
        listQueryCar: {
          entityId: this.$store.getters['user/entityId'],
          pageIndex: 1,
          pageSize: 10,
          queryParams: null,
          categoryParams:null,
          params: {
            id: undefined,
            isRobot: undefined,
          },
          fuzzySearch: true
        },
        /* car category query */
        carCategoryQuery: {
          pageIndex: 1,
          pageSize: 10,
		  loginEntityId:this.$store.getters['user/entityId'],
        },
        statusOptions: [
          '在线状态',
          '离线状态',
          '故障状态'
        ],
        typeOptions: [
          '真车',
          '模拟车',
          'carla'
        ],
        tableOptions: [
          '编辑',
          '删除',
          // '数据监控',
		  '相关用户',
		  '推送'
        ],
        // 弹出框信息
        editCarForm: {
          carEditId: '',
          carEditName: '',
          // carEditIsRobot: '0',
          // carEditIsRobotName: '',
          carEditEntityId: '',
          // carEditStatus: '',
          carEditTypeId: '',
          carEditModelId: '',
          carEditEntityName: '',
		  carEditWifiName:'',
		  carEditwifiPassword:'',
		  carEditImg:'',
		  carEditWeight:'',
		  carEditMaxWeight:'',
		  carEditNum4g:'',
		  carEditNumDiffer:'',
		  carEditActive4g:'',
		  carEditActiveDiffer:'',	
		  carEditExternalFlag:'',
		  carEditDeathDiffer:'',
		  carEditExceptionCodeVersion:''
        },
        // 运营商信息
        entityInfoOptions: [],

        // 状态列表
        entityInfoStatus: [{
            label: "在线状态",
            value: 0
          },
          {
            label: "离线状态",
            value: 1
          },
          {
            label: "故障",
            value: 2
          },
          {
            label: "异常",
            value: 64
          },
        ],
        //校验
        error_input: false,
        //批量删除CarId存储
        deleteCarsIds: [],
        //车辆类型
        carTypeOptions: [],
        carTypes:[],//车辆类型
        selectedCarTypes:[],
        carStatusMap:{
          0:"正常",
          1:"未接入",
          2:"故障",
          3:"建图中",
          4:"建轨中",
          5:"自动任务",
          6:"遥控驾驶",
          7:"待机",
          64:"异常",
        },
        tagsAll: null,
        //category search condition
        conditionMap: {
          typeId:{
            label:"机器人型号",//label
            field:"typeId",//属性名
            type:"check",//复选，目前仅支持复选
            group:"",//暂未开发
            selected: false,
            filterKey:"label",//暂未开发
            options:[
              {
                label:"真车",
                value:0,
                selected:false
              },
              {
                label:"模拟车",
                value:1,
                selected:false
              },
              {
                label:"carla",
                value:2,
                selected:false
              }
            ]
          },
          status:{
            label:"机器人状态",//label
            field:"status",//属性名//暂未使用
            type:"check",//复选，目前仅支持复选
            group:"",//暂未开发
            selected: false,
            filterKey:"label",//暂未开发
            options:[
              {
                value: 0,
                label: "正常",
                selected: false
              }, 
              {
                value: 1,
                label: "未接入",
                selected: false
              }, 
              {
                value: 3,
                label: "建图",
                selected: false
              }, 
              {
                value: 4,
                label: "建轨迹",
                selected: false
              }, 
              {
                value: 5,
                label: "自动任务",
                selected: false
              }, 
              {
                value: 6,
                label: "遥控驾驶",
                selected: false
              }, 
              {
                value: 7,
                label: "待机",
                selected: false
              }, 
              {
                value: 2,
                label: "故障",
                selected: false
              }, 
              {
                value: 64,
                label: "异常",
                selected: false
              }
            ]
          },
          entityId:{
            label:"所属单位",//label
            field:"entityId",//属性名
            type:"check",//复选，目前仅支持复选
            group:"",//暂未开发
            selected: false,
            filterKey:"label",//暂未开发
            options: [
              {
                label: '百度',
                value: 0,
                selected: false
              },
              {
                label: '阿里巴巴',
                value: 1,
                selected: false
              },
              {
                label: '腾讯',
                value: 2,
                selected: false
              },
            ],
          }
        }
        
      }
    },
    methods: {
      search(result) {
        this.listLoading = true;

        //点击搜索时//默认第一页
        this.carCategoryQuery = {
          pageIndex: 1,
          pageSize: 10
        }

        for(let index in result) {
          let temp = result[index];
          if(index === "keyWord" && temp != null && temp["values"] != null && temp["values"].length >= 1) {
            this.carCategoryQuery[index] = temp["values"][0];
            continue;
          }
          this.carCategoryQuery[index] = temp["values"];
        }
        
        this.handleFilter();

      },
      //
      queryDevice(tagsAll){
        this.tagsAll = tagsAll;
        this.pageListCarsByConditions();
      },
            /**
       * 分页查询当前单位及其子单位的车辆
       * @status enable
       */
      pageListCarsByConditions() {
        //开始加载数据列表
        //显示加载图标
        this.listLoading = true;
        // 处理查询数据封装Map

        if (this.tagsAll == null || this.tagsAll == '') {
          this.listQueryCar.queryParams = null;
        } else {

          /* let map = new Map()
          for (var key in this.tagsAll) {
            map.set(this.tagsAll[key].split(":")[0], this.tagsAll[key].split(":")[1])
          }
          params = map; */
          this.listQueryCar.queryParams = this.tagsAll;
        }
        console.log(this.listQueryCar.queryParams);

        carList(this.listQueryCar, null ).then(res => {
          let data = res.pageData;
          this.totalCountsCar = data.totalCounts;
          // 对后端数据进行解析
          this.listDataCar = data.datas.map((item, index) => {
            //所有设备的isShow默认为false，即使不于地图中展示
            item.isShow = false;
            return item;
          });
          //加载完成//结束加载
          this.listLoading = false;
        });
      },
      // 复选框
      getRowKey(row) {
        // console.log('================:', JSON.stringify(row))
        return row.id
      },
      // 选择复选框事件
      selectChange(val) {
        console.log('======================:', JSON.stringify(val));
        // this.selectdata = val // selectdata  是一个数组，存取选中的数据
      },

      init() {
        //初始化类别
        getCarTypes(this.$store.getters['user/entityId']).then(res => {
          if (res.result == '200') {
            this.carTypes = res.data;
            this.conditionMap["typeId"]["options"] = this.carTypes.map((item,index) => {
                return {
                  value: item.id,
                  label: item.name,
                  selected: false
                }
            })

            console.log(this.carTypes);
          } else {
            this.$message.error(res.message)
          }

          // getNotRepeatingCarTypes(this.$store.getters['user/entityId']).then(res => {
          //   if (res.result == '200') {
          //     this.carTypeOptions = res.data.map((item,index) => {
          //       return {
          //         value: item.name,
          //         label: item.name,
          //       }
          //     })              

          //   } else {
          //     this.$message.error(res.message)
          //   }
          // })

          this.handleFilter()
        })
        //初始化单位
        
          let entitys = JSON.parse(localStorage.entity)
          //
          let entityOptions = [];
          for (let k in entitys) {
            entityOptions.push({
              value: k,
              label: entitys[k]
            })
          }
          this.entityInfoOptions = entityOptions;
          this.conditionMap["entityId"]["options"] = entityOptions.map((item,index)=>{
            return {
              value: item.value,
              label: item.label,
              selected: false
            }
          })
        
      },
      /**
       * handleFilter 用于请求车辆数据
       */
      handleFilter() {

        this.listLoading = true
        // 对请求参数做转换
        
        carCategorySearch(this.carCategoryQuery).then(res => {
          let data = res.pageData
          this.totalCounts = data.totalCounts

          //在线状态码列表
          let carOnlineStatusArray = [0,3,4,5,6,7];
          let carErrorStatusArray = [2,64];


          // 对后端数据进行解析
          this.listData = data.datas.map(item => {
            let workStatusName = "";
            let healthStatusName = "";
            
            console.log(carOnlineStatusArray.indexOf(item.status)>=0)
            if(carOnlineStatusArray.indexOf(item.status) >= 0) {
              healthStatusName = "在线状态";
              workStatusName = this.getWorkStatusName(item.status);
            } else if(carErrorStatusArray.indexOf(item.status) >= 0) {
              healthStatusName = "故障状态";
              workStatusName = this.getWorkStatusName(item.status);
            } else {
              healthStatusName = "离线状态";
              workStatusName = "设备离线";
            }
			
			var itemEntityName = this.$store.getters['user/entityId2name'](item.entityId)
            return {
              id: item.id,
              entityId: item.entityId,
              name: item.name,
              entityName: itemEntityName,
              // status: this.statusOptions[item.status],
              status: item.status,
              workStatusName: workStatusName,
              healthStatusName: healthStatusName,
              power: item.power,
              isRobot: this.typeOptions[item.isRobot],
              longitude: item.baiduLongitude,
              latitude: item.baiduLatitude,
              createTime: formatDate(item.createTime),
              typeName: item.typeName,
              modelName: item.modelName,
			  typeId:item.typeId,
			  modelId:item.modelId,
			  img:item.img,
			  wifiName:item.wifiName,
			  wifiPassword:item.wifiPassWord,
			  weight :item.weight,
			  maxWeight :item.maxWeight,
			  num4g :item.num4g,
			  numDiffer :item.numDiffer,
			  active4g :item.active4g,
			  activeDiffer :item.activeDiffer,
			  externalFlag:item.externalFlag,
			  deathDiffer:item.deathDiffer,
			  factoryName:item.factoryName,
			  exceptionCodeVersion:item.exceptionCodeVersion
            }
          })
          
          this.listLoading = false
        });
      },
      getWorkStatusName(status) {
        if(status in this.carStatusMap) {
          return this.carStatusMap[status]
        }
        return "设备离线";
      },
      getHealthStatusName(status) {
        //TODO
      },
      // getTypeStr(typeId) {
      //   for (const item of this.carTypes) {
      //     if (item.id == typeId) {
      //       return item.name
      //     }
      //   }
      //   return '未知'
      // },
      // getModelStr(typeId) {
      //   for (const item of this.carTypes) {
      //     if (item.id == typeId) {
      //       return item.model
      //     }
      //   }
      //   return '未知'
      // },
      
      handleDelete(row) {
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          carDelete(row.id).then(res => {
            if (res.result == '2') {
              this.$alert('删除机器人成功');
              this.handleFilter();
            } else {
              this.$alert(res.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      // 批量删除
      handleDeleteAll() {
        if (this.deleteCarsIds == null || this.deleteCarsIds.length == 0) {
          this.$message.error("请先选择机器人")
          return;
        }
        let isDeleteMessge = "模拟车批量删除成功";

        if (this.deleteCarsIds.length == 1) {
          this.deleteCarsIds.every(function(cars) {
            console.log(cars);
            if (cars == undefined) {
              isDeleteMessge = "批量删除失败：所选为真车/Carla";
            } else {
              carDelete(cars.id).then(res => {
                if (res.result !== '2') {
                  isDeleteMessge = "模拟车批量删除失败";
                }
              })
            }
          })
          this.$alert(isDeleteMessge);
          this.handleFilter();
        } else {

          this.deleteCarsIds.every(function(cars) {

            if (cars != undefined) {

              carDelete(cars.id).then(res => {
                if (res.result !== '2') {
                  isDeleteMessge = "模拟车批量删除失败";
                  return false;
                }
              })
            }
            return true;

          })
          this.$alert(isDeleteMessge);
          this.handleFilter();
        }

      },
      handlePageChange(data) {
        this.carCategoryQuery.pageIndex = data.page
        this.carCategoryQuery.pageSize = data.limit
        this.handleFilter()
      },
      // 多选勾选变换
      handleSelectionChange(val) {
        // TODO
        let isRobotTrue = false;
        this.deleteCarsIds = val.map(item => {
          if (item.isRobot === "模拟车") {
            return {
              id: item.id,
              isRobot: item.isRobot
            }
          } else {
            isRobotTrue = true;
          }

        })
        /* if (isRobotTrue) {
          this.$alert("选项中包含真车/Carla不能被勾选删除,请取消勾选")
        } */
      },
      /**
       * editCar编辑车辆信息弹出框
       */
      editCar(row) {
        this.editCarForm.carEditId = row.id;
        this.editCarForm.carEditName = row.name;
        this.editCarForm.carEditEntityName = row.entityName;
		this.editCarForm.carEditImg = row.img
		this.editCarForm.carEditWifiName = row.wifiName
		this.editCarForm.carEditwifiPassword = row.wifiPassword
		
		this.editCarForm.carEditWeight = row.weight
		this.editCarForm.carEditMaxWeight = row.maxWeight
		this.editCarForm.carEditNum4g = row.num4g
		this.editCarForm.carEditNumDiffer = row.numDiffer
		this.editCarForm.carEditActive4g = row.active4g
		this.editCarForm.carEditActiveDiffer = row.activeDiffer	
		this.editCarForm.carEditExternalFlag = row.externalFlag
		this.editCarForm.carEditDeathDiffer = row.deathDiffer
		this.editCarForm.carEditExceptionCodeVersion = row.exceptionCodeVersion
		
        // this.editCarForm.carEditIsRobotName = row.isRobot;
        // this.editCarForm.carEditStatus = row.status;
		

        // //在线（包括故障不可编辑）
        // this.isSearch = true;
        // // 离线改为可编辑
        // if (this.editCarForm.carEditStatus == 1) {
        //   this.isSearch = false;
        // }
        // //
        // if ("真车" === row.isRobot) {
        //   this.editCarForm.carEditIsRobot = '0';
        // } else if ("模拟车" === row.isRobot) {
        //   this.editCarForm.carEditIsRobot = '1';
        // } else if ("carla" === row.isRobot) {
        //   this.editCarForm.carEditIsRobot = '2';
        // } else {
        //   this.editCarForm.carEditIsRobot = '3';
        // }
        
        // 获取运营商信息
        this.editCarForm.carEditEntityId = row.entityId+""

        //获取车辆类型
        getNotRepeatingCarTypes(this.$store.getters['user/entityId']).then(res => {
          if (res.result == '200') {
            this.carTypeOptions = res.data.map((item, index) => {
				return {
						value: item.id,
						label: item.name
					}
				})
            console.log(this.carTypeOptions)
          } else {
            this.$message.error(res.message)
          }
        })
			
		this.selectCarTypeName(row.typeName)	
		//车辆类型id
		this.editCarForm.carEditTypeId = row.typeId
		//车辆类型名称
		this.editCarForm.carEditModelId = row.modelId
		
		//所有表单数据加载完成，显示模态框
		this.editCarDialog = true;
      }, 
	  
      selectCarTypeName (carTypeName) {
        this.editCarForm.carEditModelId = '';
        //获取指定车辆类型名称下，所有的车辆型号
        getTypesByCarTypeName(this.$store.getters['user/entityId'],carTypeName).then(res => {
          if (res.result == '200') {
            this.selectedCarTypes = res.data.map((item, index) => {
				return {
					value: item.id,
					label: item.name,
				}
			})
          } else {
            this.$message.error(res.message)
          }
        })
      },
	  
	  //展示车辆归属用户信息
	  showCarUser(row){ 
		var loginuser = this.$store.getters['user/userName']
		if(loginuser != 'admin'){
			  this.$message.error('暂无此权限')
			  return
		}
		this.editCarUser.carUsers = ''
		getCarUsers(row.id).then(res =>{
				if (res.result == '200') {
					let car = res.data[0]
					let carusers = car.users;
					if(carusers!=null){
						var usernames = [];
						if(carusers.indexOf(",") > 0){
							var usernamessel = carusers.split(",");
							for(var i = 0 ; i < usernamessel.length ; i ++ ){
								usernames.push({'title':'已分配','name':usernamessel[i]})
							}
						}else{
							usernames = [{
								'title':'已分配',
								'name':carusers
							}]
						}
						this.editCarUser.carUsers = usernames;
					}
				} else {
				  this.$message.error(res.message)
				}
		})
		listCarUserByEntity(this.$store.getters['user/entityId']).then(res =>{
				if (res.result == '200') {
				  this.usersOptions = res.data.map((item,index) => {
				    return {
				      value: item.username,
				      label: item.username,
				    }
				  })    
				this.editCarUser.editCarId = row.id
				this.editCarUserVisible = true			  
				} else {
				  this.$message.error(res.message)
				}
		})
	  },
      /**
       * 处理操作
       */
      handleOperator(index, row) {
        switch (index) {
          case 0:
            // index: 0 表示编辑车辆
            this.editCar(row)
            break;
          case 1:
            // index: 1 表示删除车辆
            this.handleDelete(row)
            break;
          case 2:
            // index: 2 车辆分配用户
			this.showCarUser(row)
            break;
		   case 3:
				this.mqttPush(row)
				break;
			// case 3:
			// index:表示数据监控
			// this.showDataMonitor(row)
			// break;
          default:
            break;
        }
      },
      // 编辑提交
      editCarBtn() {
        this.check_inputs();
        if (!this.error_input) {
          carEditFunction(this.editCarForm).then(res => {
            if (res.result == '2') {
              this.$alert('编辑成功！');
              this.handleFilter();
              this.editCarDialog = false;
            } else {
              this.$alert(res.message);
            }
          })
        }
      },
	  
	  //车辆用户关系新增
	  handleEditCarUserForm(){
		if(this.editCarUser.editUserName == ''){
			  this.$alert('用户选择不能为空')
			  return
		}else if(this.editCarUser.carUsers.length >= 1){
			this.$alert('机器人只能绑定一个账户')
			return
		}else{
			insertCarUserTra(this.editCarUser).then(res => {
			  	if (res.result == '2') {
			  		this.$alert('添加成功！');
			  		this.editCarUserVisible = false;
			  	} else {
			  		this.$alert(res.message);
			  	}
			})
		}
	  },
	  
	   //车辆用户关系删除
	  handlDeleteCarUser(id,user){
		  deleteCarUserTra(id,user).then(res => {
		  	if (res.result == '2') {
		  		this.$alert('删除成功！');
		  		this.editCarUserVisible = false;
				this.editCarUser.carUsers = '';
		  	} else {
		  		this.$alert(res.message);
		  	}
		  })
	  },
	  
	  //MQTT信息推送
	  mqttPush(carinfo){
		  // if(carinfo.typeId != 4){
			 //  this.$alert('该车型暂不支持');
			 //  return;
		  // }
		  mqttPushCarBasic(carinfo.id,carinfo.typeId).then(res =>{
			  if(res.result == '0'){
				  this.$alert('推送成功！');
			  }else{
				  this.$alert('推送失败');
			  }
		  })
	  },
	  
      /**
       * editCarForm空值校验
       */
      check_inputs() {

        //默认无错
        this.error_input = false;
        if (this.editCarForm.carEditName === '') {
          this.$alert('机器人名称不能为空')
          this.error_input = true
          return
        }

        // if (this.editCarForm.carEditTypeId === '') {
        //   this.$alert('请选择车辆型号')
        //   this.error_input = true
        //   return
        // }

        if (this.editCarForm.carEditEntityId === '') {
          this.$alert('运营单位不能为空')
          this.error_input = true
          return
        }
      },

      /**
       * 跳转到数据监控界面并传参
       */
      showDataMonitor(row) {
        this.$router.push({
          name: 'data_monitor',
        });
        localStorage.setItem('monitorCarId', row.id)
      }
    }

  }
</script>

<style>

</style>
